export default __webpack_public_path__ + "static/media/ironman.a470fc54.jpg";